












import { Vue, Component, Prop } from 'vue-property-decorator';
import ArrowDownIcon from '../icons/ArrowDownIcon.vue';

@Component({
  components: {
    ArrowDownIcon
  }
})
export default class ExpandPanel extends Vue {
  @Prop(String) title!: string;

  expanded = false;
}
